/* Royal Hair – GA4 bridge for custom (non-ecommerce) events.
   Ecommerce events (page_view, view_item, add_to_cart, begin_checkout, purchase …) are sent by the
   Shopify Google & YouTube app and are deliberately NOT sent from here, to avoid double counting.
   This file only forwards booking and Hair Match events to the Google tag the app already loads
   (window.dataLayer / gtag, GA4 G-9F1ND0FBMX). Consent mode set by the app applies to these events too. */
(function () {
  if (window.rhAnalytics) return;
  var GA4 = 'G-9F1ND0FBMX';
  var ALLOWED = /^(booking_clicked|hair_match_started|hair_match_completed|finder_[a-z_]+)$/;
  var DROP = { comment: 1, event: 1, journey_id: 1, event_id: 1, gtm: 1 };
  var debug = /[?&]rh_debug=1/.test(location.search);

  function gtag() { window.dataLayer = window.dataLayer || []; window.dataLayer.push(arguments); }

  function clean(params) {
    var out = {};
    if (!params) return out;
    Object.keys(params).forEach(function (k) {
      var v = params[k];
      if (DROP[k] || v === null || v === undefined || v === '') return;
      if (Array.isArray(v)) v = v.join(',');
      if (typeof v === 'object') return;
      if (typeof v === 'string') v = v.slice(0, 100);
      out[k] = v;
    });
    return out;
  }

  function send(name, params) {
    if (!ALLOWED.test(name)) return false;
    var p = clean(params);
    p.send_to = GA4;
    p.page_language = (document.documentElement.lang || '').slice(0, 2);
    if (debug) p.debug_mode = true;
    gtag('event', name, p);
    if (debug && window.console) console.log('[rh-analytics]', name, p);
    return true;
  }

  /* Hair Match journey milestones (emitted by royal-hair-context.js). Step events are covered by finder_*. */
  window.addEventListener('royalhair:journey-event', function (e) {
    var d = e.detail || {};
    if (d.event === 'hair_match_started' || d.event === 'hair_match_completed') {
      send(d.event, d.properties || {});
    }
  });

  /* Booking CTA clicks to Timma (all salons, every placement). */
  function salonFrom(url) {
    if (/royalhairavdmajorstuen/i.test(url)) return 'majorstuen';
    if (/customergroup\/royalhair_skandinavia/i.test(url)) return 'all_salons';
    if (/royalhair_skandinavia/i.test(url)) return 'royalhair_skandinavia';
    return 'other';
  }
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('a[href*="timma.no"]') : null;
    if (!a) return;
    var sec = a.closest('[id^="shopify-section-"]');
    send('booking_clicked', {
      link_url: a.href.split('?')[0],
      booking_target: salonFrom(a.href),
      placement: sec ? sec.id.replace(/^shopify-section-(template--\d+__)?/, '').replace(/^sections--\d+__/, '') : 'page',
      link_text: (a.getAttribute('aria-label') || a.innerText || a.textContent || '').replace(/[\s\u2192]+/g, ' ').trim()
    });
  }, true);

  window.rhAnalytics = { send: send };
})();
